import styled from "styled-components";
import { NavLink } from "../Styles";
import globalStyles from "../../../constants/globalStyles/theme.json";

const { colors, spacing } = globalStyles;

export const Overlay = styled.div<{ $isOpen?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $isOpen }) => ($isOpen ? "100%" : "0")};
  background-color: ${({ $isOpen }) =>
    $isOpen ? colors.primary.green : "transparent"};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  transition: all 0.3s ease-in-out;
  z-index: 90;
`;

export const MenuList = styled.div<{ $isOpen?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: ${({ $isOpen }) =>
    $isOpen ? "translate(-50%, -50%)" : "translate(-50%, -150%)"};
  width: 100%;
  max-width: 380px;
  padding: ${spacing.space24};
  box-sizing: border-box;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
`;

export const MenuItem = styled(NavLink)`
  display: block;
  color: ${colors.primary.offWhite};
  text-decoration: none;
  margin-bottom: ${spacing.space32};
  font-size: 2.5rem;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.space32};
`;

export const Name = styled.span`
  color: ${colors.primary.offWhite};
  font-size: 2rem;
`;
